<!-- Left edge button -->
@if (showLeftEdgeButton) {
  <cs-button secondary overlay small
    class="task-calendar__edge-button task-calendar__edge-button--left" (click)="scrollToSelectedFromButton()">
    <cs-icon name="skip-back"></cs-icon>
  </cs-button>
}

<!-- Calendar container -->
<div #container class="task-calendar__container" cdkScrollable (wheel)="onWheel($event)">
  @for (date of dates; track date.date.toMillis()) {
    <!-- data-date is how a test addresses one particular day, same as the
         full-page calendar in task-calendar-page.html -->
    <cs-task-calendar-day [date]="date.date" [attr.data-date]="date.dateKey" [taskStatus]="date.taskStatus"
      [isSelected]="date.isSelected" [isToday]="date.isToday" [showDayOfWeek]="true" [showStatus]="true"
    (dateClick)="onDateClick(date)"></cs-task-calendar-day>
  }
</div>

<!-- Right edge button -->
@if (showRightEdgeButton) {
  <cs-button secondary overlay small
    class="task-calendar__edge-button task-calendar__edge-button--right" (click)="scrollToSelectedFromButton()">
    <cs-icon name="skip-forward"></cs-icon>
  </cs-button>
}